var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
const BASE_URL = 'https://uploads.documents.cimpress.io/v1/uploads';
const DEFAULT_DELETE_AFTER_DAYS = 30;
const PROCESS = '{"type":"storeOnly"}';
export function uploadV1({ headers, file, process = PROCESS, deleteAfterDays = DEFAULT_DELETE_AFTER_DAYS, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const path = `${BASE_URL}?tenant=default&deleteAfterDays=${deleteAfterDays}&process=${process}`;
        const bodyFormData = new FormData();
        bodyFormData.append('image', file);
        return axios({
            method: 'post',
            url: path,
            headers,
            data: bodyFormData,
        });
    });
}
//# sourceMappingURL=UploadV1.js.map